// extracted by mini-css-extract-plugin
module.exports = {"img":"HomePageCheckTypeModal_img__xWfPb"};